<script>
  export let status = '';
  $: cls = (status || '').toLowerCase().replace(/[^a-z]+/g, '-');
</script>

<span class="badge {cls}">{status}</span>

<style>
  .badge { display: inline-block; padding: .15rem .55rem; border-radius: 999px; font-size: .72rem; font-weight: 600; background: #e5e7eb; color: #374151; }
  .unfulfilled { background: #fde68a; color: #92400e; }
  .partially-fulfilled { background: #fed7aa; color: #9a3412; }
  .fulfilled { background: #bbf7d0; color: #166534; }
  .paid { background: #bbf7d0; color: #166534; }
</style>
